import React from 'react';
import config from '../config';
import PlanPage from './PlanPage';

function Corporate() {
  return (
    <PlanPage
      title="Corporate Wellness Plans"
      subtitle="Premium fruit bowls for your office team — delivered daily."
      message="Boost your team's productivity and health with FALSUTRA's Corporate Wellness Plans. Fresh, nutritious fruit bowls delivered to your office every working day."
      plans={config.corporatePlans}
    />
  );
}

export default Corporate;
